import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { StoryModel } from 'types/story';
import { IFRAME_ACTIONS } from 'common/constants';
import { parseURL } from 'common/utils/parse-url';
import { IframeTunnel } from 'common/utils/iframe-tunnel';
import Story from 'client/components/pages/Story';

type State = {
	story: StoryModel | null;
	storyId: string;
};

type Props = RouteComponentProps;

class Preview extends Component<Props, State> {
	state: State = {
		story: null,
		storyId: '',
	};

	IframeTunnel: IframeTunnel;

	constructor(props) {
		super(props);

		this.IframeTunnel = new IframeTunnel({
			id: 'Preview',
			messageReceiver: this.messageReceiver,
			filter: [IFRAME_ACTIONS.GET_STORY],
		});
		this.IframeTunnel.init();
	}

	static getDerivedStateFromProps(props) {
		const { storyId } = parseURL(props.location.search).searchObject;
		return { storyId };
	}

	async componentDidMount() {
		const { story, storyId } = this.state;
		if (story || !storyId) {
			return null;
		}

		this.IframeTunnel.messageTransmitter({
			target: IframeTunnel.targets.admin,
			action: IFRAME_ACTIONS.GET_STORY,
		});

		return null;
	}

	componentWillUnmount() {
		this.IframeTunnel.destroy();
	}

	messageReceiver = (event: MessageEvent) => {
		this.setState({ story: event.data.payload });
	};

	render() {
		const { story } = this.state;

		if (!story) return null;

		return story && <Story {...this.props} story={story} />;
	}
}

export default Preview;
